<template>
  <SimplePage title="ご利用開始の注意事項" hideStoreName showBack :onHome="back">
    <template #main>
      <LoadingIndicator v-if="busy" />
      <div class="main">
        <div class="term">
          <TextArea class="text" :value="termText" noneAutosize />
          <div class="agreement">
            <Button primary @click="agree">同意して設定する</Button>
          </div>
        </div>
      </div>
    </template>
  </SimplePage>
</template>

<script>
import { mapState } from 'vuex'
import SimplePage from '@/components/templates/SimplePage'
import Button from '@/components/atoms/Button'
import TextArea from '@/components/atoms/TextArea'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'

export default {
  name: 'MailConversion',
  components: {
    SimplePage,
    Button,
    TextArea,
    LoadingIndicator,
  },
  computed: {
    ...mapState({
      busy: state => state.mailConversion.busy,
    }),
    termText() {
      return '本サービスを利用する際には、下記注意事項をよくお読みください。お客様が本サービスの利用を開始された場合、当社は、お客様が本注意事項に同意したものとみなします。\n\n・本サービスの利用開始後、ユーザーが外部サイト（当社が別途指定するサイトに限ります。以下同じ）を利用して行った予約にかかる情報（以下「外部サイト予約情報」）が「テーブル一覧画面」の「テーブル未指定」に予定として反映されます。取り込まれる予約詳細情報は、外部サイトの予約内容により、異なります。\n・当社が発行する外部サイト予約情報の取込み用メールアドレス（以下「取込み用アドレス」）を外部サイトの通知設定部分に設定いただいた場合、取込み用アドレス宛に届くすべてのメールおよび外部サイト予約情報が「メール受信ボックス」に保存されます。\n・本サービスのご利用に起因して、予約に関する不具合等の問題が生じた場合であっても当社は責任を負いません。\n・本サービスは完全性を保証するものではありません。また、以下に掲げる場合、外部サイト予約情報が予定に反映されない場合がございます。\n  ① 外部サイト側の事情で予約受付ができない状態になっている場合\n  ② 外部サイトの運営主体が、予約者に送付する予約情報の通知に係るメールの形式等に変更があった場合\n  ③ 外部サイトにて提供される予約サービスの内容または仕様の変更、若しくは当該サービスが終了した場合\n  ④ 当社とお客様との間のレストラン加盟契約が終了した場合\n  ⑤ 当社ウェブサイト上のお客様の店舗に係る情報掲載ページにおいて、予約掲載情報がすべて非掲載となった日から起算して61日間同じ状態が継続した場合\n  ⑥ その他、当社ウェブサイトまたは外部サイトのシステム不具合、システムメンテナンスおよび本サービス外に起因する事象が発生した場合\n  ⑦ お客様が、「ぐるなび台帳利用条件」その他当社が定める諸条件に違反した場合\n・本サービスのご利用にあたり、当社がお客様に発行する外部サイト予約情報取込み用のメールアドレスは、本サービスの利用以外にはご利用いただけません。\n--------------------------------------------------------------------\n改定日：2020年2月25日'
    },
  },
  methods: {
    back() {
      location.assign('/store/init')
    },
    async agree() {
      if (await this.$store.dispatch('mailConversion/agree'))
        this.$router.push({ name: 'MailConversion', params: { confirmed: true } })
    },
  },
}
</script>
<style lang="postcss" scoped>
.main {
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  padding: 24px;
}

.text {
  display: block;
  height: 592px;
  line-height: 2;
  padding: 32px;
  resize: none;
}

.agreement {
  margin-top: 24px;

  button {
    margin: 0 auto;
    width: 392px;
  }
}
</style>
